import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ContentFiltersKeys } from '../../../ts/models/ContentFilters';
import { IStringValuedFilterClause } from '../../../ts/ServerApi/types/IFilterClause';
import { showContentTypes, toggleShowWorkbooksAsViews } from '../../actions/spaces/ContentExplorerFilterActions';
import { selectSpecificMixedContentFilterClause } from '../../selectors/ContentFilterSelectors';
import { siteUrlsSelector } from '../../selectors/SiteUrlsSelectors';
import { AppState } from '../../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../utils/ConnectUtils';
import { BackgroundJobsSpace, BackgroundJobsSpaceDispatchProps, BackgroundJobsSpaceOwnProps, BackgroundJobsSpaceStateProps } from './BackgroundJobsSpace';


const mapStateToProps: MapStateToProps<BackgroundJobsSpaceStateProps> = (state: AppState) => ({
  urls: siteUrlsSelector(state),
  statusFilter: selectSpecificMixedContentFilterClause(state, ContentFiltersKeys.backgroundJobStatus) as IStringValuedFilterClause,
});

const mapDispatchToProps: MapDispatchToProps<BackgroundJobsSpaceDispatchProps> = (dispatch) => bindActionCreators({
  filterSelected: showContentTypes,
  toggleShowWorkbooksAsViews: toggleShowWorkbooksAsViews,
}, dispatch);

export const ConnectedBackgroundJobsSpace: React.ComponentClass<BackgroundJobsSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(BackgroundJobsSpace);
